import React from 'react';
import { MessageType } from '../../types';
import InboxMessageHeader from '../InboxMessageHeader';
import './styles.css';

const InboxMessage = ({ message }) => (
	<div className="inbox-message">
		<InboxMessageHeader message={message} />
		<p>{message.subject}</p>
		<p>
			{message.message.split('\n').map((item, key) => {
				return (
					<span key={key}>
						{item}
						<br />
					</span>
				);
			})}
		</p>
	</div>
);

InboxMessage.propTypes = {
	message: MessageType.isRequired
};

export default InboxMessage;
